import { render, staticRenderFns } from "./VerObra.vue?vue&type=template&id=07f84478&"
import script from "./VerObra.vue?vue&type=script&lang=js&"
export * from "./VerObra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports